/**
 * BriqueChart에서 사용할 기본적인 Method 정의
 */

// import Plotly from 'plotly.js-dist'
import BriqueChart from './BriqueChart.vue'

export default {
  G_LOADING_BAR: undefined, // Store에 있는 Global 로딩바(App.vue에서 설정함)

  /**
   * 차트를 그리기 전인가?
   * @param {Object} element  Chart Element
   * @returns
   */
  isBeforeNewPlot (element) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    return !element.layout
  },

  /**
   * 차트를 그린적이 있는가?
   * @param {Object} element  Chart Element
   * @returns
   */
  isAfterNewPlot (element) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    return !!element.layout
  },

  /**
   * 마우스 위치로부터 Point를 구한다.
   * @param {Object} element Chart Element
   * @param {Integer} xpx 구할 곳의 X좌표, 차트 Div의 좌측으로부터 떨어진 거리(px)
   * @param {Integer} ypx 구할 곳의 Y좌표, 차트 Div의 상단으로부터 떨어진 거리(px)
   * @param {String} hovermode 구할 Point 모드
   * @returns
   */
  async getPoints (element, xpx, ypx, hovermode = 'closest') {
    // event.target이 있으면 plotly_before event를 보내버린다.
    let event = { xpx, ypx }

    let oldHoverMode = element._fullLayout.hovermode
    element._fullLayout.hovermode = hovermode
    element.layout.hovermode = hovermode
    // element.layout.hovermode = hovermode
    event.hovermode = hovermode
    // event.hovermode = hovermode ?? 'closest'// 마우스가 위치한 곳의 1개의 Point를 구하기 위함

    // var dbb = event?.target?.getBoundingClientRect()

    // event.xpx = xpx ?? (event.clientX - dbb.left)
    // event.ypx = ypx ?? (event.clientY - dbb.top)

    let oldHoverdata = element._hoverdata
    let hoverdata
    let promise = new Promise((resolve) => {
      // Point 를 구해서 element._hoverdata에 넣는다.
      BriqueChart.Fx.hover(element, event, 'xy', true)// true : plotly_hover event를 skip하기 위함, Fx.hover()가 throttle로 50ms 지연되게 되어 있음

      setTimeout(() => {
        hoverdata = element._hoverdata

        element.briqueChartData.selectedSeriesNameForContextMenu = hoverdata[0].data.name
        element._hoverdata = oldHoverdata// 원래 값으로 되돌린다.

        element._fullLayout.hovermode = oldHoverMode
        element.layout.hovermode = oldHoverMode

        resolve(hoverdata)
      }, 100)
    })

    await promise

    return hoverdata
  }

}
